const SEEN_PREFIX = 'announcement-seen'

export type Announcement =
  | 'insurance-launch'
  | 'product-picker-first-login'
  | 'product-switcher-tip'

const key = (announcement: Announcement, userKey: string) =>
  `${SEEN_PREFIX}:${announcement}:${userKey}`

export const hasSeenAnnouncement = (
  announcement: Announcement,
  userKey: string,
) => localStorage.getItem(key(announcement, userKey)) === 'true'

export const markAnnouncementSeen = (
  announcement: Announcement,
  userKey: string,
) => localStorage.setItem(key(announcement, userKey), 'true')

export function clearStoragePreservingAnnouncements() {
  const preserved = Object.keys(localStorage)
    .filter((storageKey) => storageKey.startsWith(`${SEEN_PREFIX}:`))
    .map(
      (storageKey) => [storageKey, localStorage.getItem(storageKey)] as const,
    )

  localStorage.clear()
  preserved.forEach(([storageKey, value]) => {
    if (value !== null) {
      localStorage.setItem(storageKey, value)
    }
  })
}
